import { Checkbox } from "@/components/_atoms/checkbox";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";

import { type SelectedEntity, useCreateDataRequestStore } from "./create-data-request-state";

type EntityType = SelectedEntity["entityType"];

export function CheckboxHeaderCell({
  entityType,
  allEntityList,
}: {
  entityType: EntityType;
  allEntityList: SelectedEntity[];
}) {
  const { t } = useDomainTranslation("data-request");
  const selectedEntities = useCreateDataRequestStore((s) => s.selectedEntities);
  const setSelectedEntities = useCreateDataRequestStore((s) => s.setSelectedEntities);

  const selectedIdSet = new Set(
    selectedEntities.filter((e) => e.entityType === entityType).map((e) => e.entityId),
  );
  const allSelected = allEntityList.length > 0 && allEntityList.every((e) => selectedIdSet.has(e.entityId));

  const handleToggleAll = () => {
    const otherTypeEntities = selectedEntities.filter((e) => e.entityType !== entityType);
    if (allSelected) {
      setSelectedEntities(otherTypeEntities);
    } else {
      setSelectedEntities([...otherTypeEntities, ...allEntityList]);
    }
  };

  return (
    <div className="flex items-center justify-center">
      <Checkbox
        checked={allSelected}
        onCheckedChange={handleToggleAll}
        aria-label={t("createDialog.selectAllEntities")}
      />
    </div>
  );
}
